import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Icon } from '../icon/icon.component.js';
import { StyledAlert } from './alert.style.js';

const Alert = props => {
    const { className = '', children, margin } = props, rest = __rest(props, ["className", "children", "margin"]);
    if (!children)
        return null;
    return (jsxs(StyledAlert, Object.assign({ className: className, margin: margin, role: "alert" }, rest, { children: [jsx(Icon, { color: "errorBright", icon: "ExclamationCircleInverted", margin: { right: '8px' } }, void 0), children] }), void 0));
};

export { Alert };
